import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetInstallationsEnabledModulesReqData } from "../license/GetInstallationsEnabledModulesReqData";
import { GetInstallationsWithoutLicensesResData } from "./GetInstallationsWithoutLicensesResData";

const ENDPOINT = "/license/nolicense";

export class GetInstallationsWithoutLicensesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetInstallationsEnabledModulesReqData;

    constructor(payload: GetInstallationsEnabledModulesReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetInstallationsWithoutLicensesResData> {
        let res = await this.executeCommand(this.payload);
        return new GetInstallationsWithoutLicensesResData(res);
    }
}
